module.exports = __webpack_public_path__ + "img/SHORT-SLEEVE TEE_FRONT_BLACK-BACK.f58bff54.jpg";